module.exports = __webpack_public_path__ + "static/cesar-8bb882c4e94d9008b48bff6b0a87169e.jpg";